/* eslint-disable no-unused-vars */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppHeader from 'components/AppHeader'
import Routes from 'components/Routes'
import getAppCssModifiers from 'services/Configuration/helpers/getAppCssModifiers'
import 'typeface-roboto'
import styles from 'styles/index.css'
import './style.css'


export default class App extends Component {
    static propTypes = {
        initializeApp: PropTypes.func.isRequired,
        cssModifiers: PropTypes.shape({}).isRequired,
        wrapperDeviceType: PropTypes.string.isRequired,
        isFocusedItemsCreationForm: PropTypes.bool.isRequired
    }

    componentDidMount() {
        this.props.initializeApp()
    }

    render() {
        const isEmptyListCssClass = this.props.isListEmpty
            ? 'app_list-empty'
            : ''
        const isFocusedItemsCreationForm = this.props.isFocusedItemsCreationForm
            ? 'app_itemsCreationFormActive'
            : ''
        return (
            <div className={`app ${isEmptyListCssClass} app_wrapperDeviceType_${this.props.wrapperDeviceType} ${getAppCssModifiers(this.props.cssModifiers)} ${isFocusedItemsCreationForm}`}>
                <AppHeader />
                <Routes />
            </div>
        )
    }
}
